import { STATUS_META } from "../lib/api";

export const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || { label: status, color: "bg-slate-100 text-slate-700 ring-slate-200", dot: "bg-slate-400" };
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center gap-1.5 whitespace-nowrap text-[11px] font-semibold px-2.5 py-1 rounded-full ring-1 ring-inset ${meta.color}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
};
